(() => {
  const imgUrl = (src, width) => (src ? src + (src.includes('?') ? '&' : '?') + 'width=' + width : null);
  /* Shopify's server-rendered `| money` groups thousands ($1,234.56); a plain
     toFixed(2) drops the separator on every AJAX repaint, so format with Intl
     in the shop's currency and fall back to the old plain form on engines
     without Intl. */
  const shopCurrency = () => {
    try {
      if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
        return window.Shopify.currency.active;
      }
    } catch (e) {}
    return 'USD';
  };
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: shopCurrency()
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  };
  const linePriceHtml = (item) => {
    var fin = item.final_line_price;
    var orig = (item.original_line_price != null) ? item.original_line_price : fin;
    if (orig > fin) {
      var label = '';
      var allocs = item.line_level_discount_allocations || [];
      if (allocs.length && allocs[0] && allocs[0].discount_application && allocs[0].discount_application.title) {
        label = '<span class="nru-cart-item-discount">' + esc(allocs[0].discount_application.title) + '</span>';
      }
      return '<span class="nru-cart-was">' + money(orig) + '</span> <span class="nru-cart-now">' + money(fin) + '</span>' + label;
    }
    return money(fin);
  };
  const esc = (s) =>
    String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* The picture a URL points at, with the query string, the scheme and any
     size suffix taken off, so the same photo asked for at two widths compares
     equal. Used to find a copy of a thumbnail the browser has already
     decoded. */
  const photoKey = (url) => {
    let s = String(url || '');
    if (!s) return '';
    try {
      const resolved = new URL(s, document.baseURI);
      s = resolved.origin + resolved.pathname;
    } catch (e) {
      s = s.split('?')[0].split('#')[0];
    }
    return s.replace(/_(?:\d+x\d*|x\d+)(?=\.[a-z0-9]+$)/i, '').toLowerCase();
  };

  /* Damerau-Levenshtein (optimal string alignment): counts an adjacent
     letter swap ("sanidng" -> "sanding") as 1 edit instead of 2. */
  function editDistance(a, b) {
    const al = a.length;
    const bl = b.length;
    const d = [];
    for (let i = 0; i <= al; i++) d[i] = [i];
    for (let j = 0; j <= bl; j++) d[0][j] = j;
    for (let i = 1; i <= al; i++) {
      for (let j = 1; j <= bl; j++) {
        const cost = a[i - 1] === b[j - 1] ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[al][bl];
  }

  function wordTolerance(len) {
    if (len <= 2) return 0;
    if (len <= 5) return 1;
    return 2;
  }

  /* Best fuzzy distance of one query word against any word in the text
     (also tries the text word's prefix, so partial typing still matches). */
  function bestWordScore(qword, words) {
    const tol = wordTolerance(qword.length);
    let best = Infinity;
    for (let i = 0; i < words.length; i++) {
      const w = words[i];
      if (w.indexOf(qword) !== -1) return 0;
      let dist = editDistance(qword, w);
      if (w.length > qword.length + 1) {
        dist = Math.min(dist, editDistance(qword, w.slice(0, qword.length + 1)));
      }
      if (dist < best) best = dist;
      if (best === 0) break;
    }
    return best <= tol ? best : Infinity;
  }

  /* Every word of the query must fuzzily match some word of the text.
     "sanidng band" matches "Professional Sanding Bands" because
     sanidng~sanding (1 swap) and band~bands (1 edit). */
  function fuzzyScore(query, text) {
    if (!text) return Infinity;
    const t = String(text).toLowerCase();
    const q = String(query).toLowerCase().trim();
    if (!q) return Infinity;
    if (t.indexOf(q) !== -1) return 0;
    const words = t.split(/[^a-z0-9]+/).filter(Boolean);
    if (!words.length) return Infinity;
    const qwords = q.split(/\s+/).filter(Boolean);
    let total = 0;
    for (let i = 0; i < qwords.length; i++) {
      const s = bestWordScore(qwords[i], words);
      if (s === Infinity) return Infinity;
      total += s;
    }
    return total / qwords.length;
  }

  class NruFloatingSearch extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.fab = this.querySelector('[data-nru-search-toggle]');
      this.badge = this.querySelector('[data-nru-cart-badge]');
      this.overlay = this.querySelector('[data-nru-search-overlay]');
      this.drawer = this.querySelector('[data-nru-drawer]');
      this.closeBtn = this.querySelector('[data-nru-search-close]');
      this.track = this.querySelector('[data-nru-track]');
      this.tabstrip = this.querySelector('[data-nru-tabstrip]');
      this.tablist = this.querySelector('[data-nru-tablist]');
      this.indicator = this.querySelector('[data-nru-tab-indicator]');
      this.tabCount = this.querySelector('[data-nru-tab-count]');
      this.form = this.querySelector('[data-nru-search-form]');
      this.input = this.querySelector('[data-nru-search-input]');
      this.statusEl = this.querySelector('[data-nru-search-status]');
      this.brandsEl = this.querySelector('[data-nru-search-brands]');
      this.brandChipsEl = this.querySelector('[data-nru-brand-chips]');
      this.resultsEl = this.querySelector('[data-nru-search-results]');
      this.viewAllEl = this.querySelector('[data-nru-view-all]');
      this.cartItemsEl = this.querySelector('[data-nru-cart-items]');
      this.cartSubtotalEl = this.querySelector('[data-nru-cart-subtotal]');
      this.cartFooterEl = this.querySelector('[data-nru-cart-footer]');
      this.cartShippingBarEl = this.querySelector('[data-nru-cart-shipping-bar]');
      this.cartShippingMsgEl = this.querySelector('[data-nru-cart-shipping-msg]');
      this.toastEl = this.querySelector('[data-nru-toast]');

      this.tabs = this.tablist ? Array.prototype.slice.call(this.tablist.querySelectorAll('[data-nru-tab]')) : [];
      this.tabNames = this.tabs.map((btn) => btn.getAttribute('data-nru-tab'));
      this.panels = this.tabNames
        .map((name) => this.querySelector('[data-nru-panel="' + name + '"]'))
        .filter(Boolean);

      this.freeShippingThreshold = 7500;
      /* Every cart write made by something other than this drawer, counted, so
         an answer that was already on its way when one of them landed is never
         mistaken for the current cart. */
      this.foreignCartWrites = 0;
      this.activeTab = 'search';
      this.cartCache = null;
      this.pendingAdd = null;
      this.pendingTimers = new Map();
      this.syncChain = Promise.resolve();
      this.allProductsCache = null;
      this.debounceTimer = null;
      this.searchToken = 0;
      this.toastTimer = null;
      this.closeTimer = null;
      this.parkTimer = null;
      this.parkToken = 0;

      const vendorsEl = this.querySelector('[data-nru-vendors]');
      this.vendors = [];
      if (vendorsEl) {
        try {
          this.vendors = JSON.parse(vendorsEl.textContent) || [];
        } catch (e) {
          this.vendors = [];
        }
      }

      // --- NRU safety guard -------------------------------
      // If the floating-search markup is not fully present when this runs,
      // bail out cleanly instead of throwing
      // "Cannot read properties of null (reading 'addEventListener')".
      if (!this.fab || !this.closeBtn || !this.overlay || !this.input || !this.form ||
          !this.track || !this.tablist || !this.tabs.length ||
          this.panels.length !== this.tabs.length) {
        this._init = false;
        return;
      }
      // ---------------------------------------------------------------------

      /* The track is exactly as wide as it has panels, so adding a fifth panel
         to the markup needs no arithmetic anywhere. */
      this.track.style.setProperty('--nru-panels', String(this.panels.length));

      this.fab.addEventListener('click', () => this.open('search', true));
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', (e) => {
        if (e.target === this.overlay) this.close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.overlay.classList.contains('is-open')) this.close();
      });
      this.input.addEventListener('input', (e) => this.onInput(e));
      this.form.addEventListener('submit', (e) => {
        if (!this.input.value.trim().length) e.preventDefault();
      });
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && this.input.value.trim().length) {
          e.preventDefault();
          if (typeof this.form.requestSubmit === 'function') this.form.requestSubmit();
          else this.form.submit();
        }
      });

      this.tabs.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          this.switchTab(this.tabNames[index]);
          this.focusPanel(this.tabNames[index], true);
        });
        btn.addEventListener('keydown', (e) => this.onTabKeydown(e, index));
      });

      /* The empty saved / recently viewed / cart panels each offer a way back
         to searching. */
      this.addEventListener('click', (e) => {
        const t = e.target;
        if (t && t.closest && t.closest('[data-nru-panel-search]')) {
          this.switchTab('search');
          this.focusPanel('search', true);
        }
      });

      let resizeTimer = null;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => this.moveIndicator(), 120);
      });

      document.addEventListener('cart:refresh', () => this.refreshCartBadge());
      document.addEventListener('cart:updated', () => this.refreshCartBadge());
      document.addEventListener('cart:item-added', () => this.refreshCartBadge());
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => this.refreshCartBadge());
      }
      this.patchCartFetch();
      this.parkInactive(0);
      this.moveIndicator();
      this.refreshCartBadge();
    }

    reducedMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (e) {
        return false;
      }
    }

    /* Watch every cart mutation on the page (quick-add buttons, apps, theme
       forms) so the badge and drawer always stay in sync, no matter which
       surface changed the cart. An add also hands us the line Shopify just
       created, which is enough to show the new row straight away instead of
       waiting on a second round trip to /cart.js. */
    patchCartFetch() {
      if (window.__nruCartFetchPatched) return;
      window.__nruCartFetchPatched = true;
      const self = this;
      const origFetch = window.fetch;
      window.fetch = function () {
        const arg = arguments[0];
        const url = typeof arg === 'string' ? arg : (arg && arg.url) || '';
        const result = origFetch.apply(this, arguments);
        if (!self._selfCartCall && /\/cart\/(add|change|update|clear)/.test(url)) {
          if (/\/cart\/add/.test(url)) {
            const added = result
              .then((res) => (res && res.ok ? res.clone().json() : null))
              .then((body) => self.applyAddResponse(body))
              .catch(() => {});
            self.pendingAdd = added;
            added.then(() => {
              if (self.pendingAdd === added) self.pendingAdd = null;
            });
          }
          result
            .then(() => {
              self.foreignCartWrites++;
              self.refreshCartBadge();
            })
            .catch(() => {});
        }
        return result;
      };
    }

    /* Fold the line /cart/add.js just returned into the cart we already hold.
       Addressed by line key and written as an absolute value, so applying the
       same response twice (the /cart.js refresh can land first) changes
       nothing. */
    applyAddResponse(payload) {
      const cart = this.cartCache;
      if (!cart || !Array.isArray(cart.items) || !payload) return;
      const lines = Array.isArray(payload.items) ? payload.items : (payload.key ? [payload] : []);
      if (!lines.length) return;

      lines.forEach((line) => {
        if (!line || !line.key) return;
        let at = -1;
        for (let i = 0; i < cart.items.length; i++) {
          if (cart.items[i].key === line.key) {
            at = i;
            break;
          }
        }
        const next = typeof line.final_line_price === 'number' ? line.final_line_price : 0;
        if (at > -1) {
          const prev = typeof cart.items[at].final_line_price === 'number' ? cart.items[at].final_line_price : 0;
          cart.total_price = (cart.total_price || 0) + (next - prev);
          cart.items[at] = line;
        } else {
          cart.items.push(line);
          cart.total_price = (cart.total_price || 0) + next;
        }
      });

      cart.item_count = cart.items.reduce((sum, i) => sum + (i.quantity || 0), 0);
      this.updateBadge(cart.item_count);
      if (this.activeTab === 'cart' && this.overlay.classList.contains('is-open')) this.paintCart();
      else this.updateTotalsUI();
    }

    /* ---------- open / close / tabs ---------- */

    open(tab, fromGesture) {
      clearTimeout(this.closeTimer);
      this.closeTimer = null;
      this.overlay.classList.remove('is-closing');
      this.overlay.classList.add('is-open');
      this.fab.setAttribute('aria-expanded', 'true');
      document.body.classList.add('nru-search-lock');
      this.switchTab(tab || 'search', true);
      this.focusPanel(this.activeTab, fromGesture);
    }

    /* Kept as a name other scripts can call. */
    openTab(tab) {
      this.open(tab, true);
    }

    /* iOS Safari only raises the keyboard for a focus() that runs synchronously
       in the same task as the user's tap, so when open() comes straight from a
       click we focus here instead of on a timer. By this point the overlay
       already has .is-open and switchTab has placed the track, and reading
       getClientRects() flushes that style change and proves the field is in the
       layout -- focusing a display:none input silently fails. preventScroll
       keeps the still-transformed panel from scrolling the page. The 360ms call
       stays as the fallback for opens that are not a direct gesture, and is
       skipped when the field already has focus so it can never move the caret
       a second time. */
    focusInput(fromGesture) {
      const input = this.input;
      if (!input) return;
      if (fromGesture && input.getClientRects().length) {
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          /* silent */
        }
      }
      setTimeout(() => {
        if (!this.overlay || !this.overlay.classList.contains('is-open')) return;
        if (this.activeTab !== 'search') return;
        if (document.activeElement === input) return;
        if (!input.getClientRects().length) return;
        try {
          input.focus({ preventScroll: true });
        } catch (e) {
          /* silent */
        }
      }, 360);
    }

    focusPanel(tab, fromGesture) {
      if (tab === 'search') {
        this.focusInput(fromGesture);
        return;
      }
      const panel = this.panelFor(tab);
      if (!panel) return;
      try {
        panel.focus({ preventScroll: true });
      } catch (e) {
        /* silent */
      }
    }

    panelFor(tab) {
      const at = this.tabNames.indexOf(tab);
      return at > -1 ? this.panels[at] : null;
    }

    close() {
      if (!this.overlay.classList.contains('is-open')) return;
      this.overlay.classList.add('is-closing');
      document.body.classList.remove('nru-search-lock');
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => {
        this.closeTimer = null;
        this.overlay.classList.remove('is-open', 'is-closing');
        this.fab.setAttribute('aria-expanded', 'false');
        try {
          this.fab.focus({ preventScroll: true });
        } catch (e) {
          /* silent */
        }
      }, 300);
    }

    switchTab(tab, instant) {
      const at = this.tabNames.indexOf(tab);
      const index = at > -1 ? at : 0;
      const name = this.tabNames[index];
      const count = this.panels.length;
      this.activeTab = name;

      this.tabs.forEach((btn, n) => {
        const on = n === index;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.tabIndex = on ? 0 : -1;
      });

      if (instant) this.drawer.classList.add('no-anim');

      /* Every panel is put back in view for the length of the slide: the one
         leaving has to stay on screen while it moves. */
      this.panels.forEach((panel) => {
        panel.classList.remove('is-parked');
        panel.removeAttribute('aria-hidden');
        if ('inert' in panel) panel.inert = false;
        else panel.removeAttribute('inert');
      });

      this.track.style.transform = 'translateX(-' + (index * (100 / count)) + '%)';
      this.moveIndicator(index);

      if (instant) {
        requestAnimationFrame(() => requestAnimationFrame(() => this.drawer.classList.remove('no-anim')));
      }

      this.parkToken++;
      const token = this.parkToken;
      clearTimeout(this.parkTimer);
      if (instant || this.reducedMotion()) {
        this.parkInactive(index);
      } else {
        this.parkTimer = setTimeout(() => {
          if (token === this.parkToken) this.parkInactive(index);
        }, 380);
      }

      this.scrollTabIntoView(index);
      this.announcePanel(name);

      if (name === 'cart') this.renderCart();
    }

    /* Anything not on screen is out of the tab order as well: a translated
       track keeps its off-screen panels in the layout, so without this the
       Tab key walks through three invisible panels. */
    parkInactive(index) {
      this.panels.forEach((panel, n) => {
        if (n === index) return;
        panel.classList.add('is-parked');
        panel.setAttribute('aria-hidden', 'true');
        if ('inert' in panel) panel.inert = true;
        else panel.setAttribute('inert', '');
      });
    }

    moveIndicator(index) {
      if (!this.indicator) return;
      const at = typeof index === 'number' ? index : Math.max(0, this.tabNames.indexOf(this.activeTab));
      const tab = this.tabs[at];
      if (!tab) return;
      this.indicator.style.width = tab.offsetWidth + 'px';
      this.indicator.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }

    scrollTabIntoView(index) {
      const strip = this.tabstrip;
      const tab = this.tabs[index];
      if (!strip || !tab) return;
      const left = tab.offsetLeft;
      const right = left + tab.offsetWidth;
      const from = strip.scrollLeft;
      const to = from + strip.clientWidth;
      let target = from;
      if (left < from) target = Math.max(0, left - 12);
      else if (right > to) target = right - strip.clientWidth + 12;
      if (target === from) return;
      if (typeof strip.scrollTo === 'function') {
        strip.scrollTo({ left: target, behavior: this.reducedMotion() ? 'auto' : 'smooth' });
      } else {
        strip.scrollLeft = target;
      }
    }

    /* The saved and recently viewed panels are filled by their own scripts;
       this is how they hear that they are on screen. */
    announcePanel(name) {
      try {
        this.dispatchEvent(new CustomEvent('nru:panel', { bubbles: true, detail: { tab: name } }));
      } catch (e) {
        /* silent */
      }
    }

    onTabKeydown(event, index) {
      const total = this.tabs.length;
      let next = -1;
      if (event.key === 'ArrowRight') next = (index + 1) % total;
      else if (event.key === 'ArrowLeft') next = (index - 1 + total) % total;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = total - 1;
      else return;
      event.preventDefault();
      this.switchTab(this.tabNames[next]);
      try {
        this.tabs[next].focus({ preventScroll: true });
      } catch (e) {
        /* silent */
      }
    }

    /* ---------- cart badge ---------- */

    async refreshCartBadge() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        if (this.pendingTimers.size === 0) {
          this.cartCache = cart;
          this.updateBadge(cart.item_count);
          if (this.overlay.classList.contains('is-open') && this.activeTab === 'cart') {
            this.paintCart();
          } else {
            this.updateTotalsUI();
          }
        }
      } catch (e) {
        /* silent */
      }
    }

    updateBadge(count) {
      const show = count > 0;
      const text = String(count);
      if (show && this.badge.textContent !== text) {
        this.badge.textContent = text;
        this.badge.classList.remove('nru-pulse');
        void this.badge.offsetWidth;
        this.badge.classList.add('nru-pulse');
      }
      if (this.tabCount && this.tabCount.textContent !== text) this.tabCount.textContent = text;
      this.badge.style.display = show ? 'flex' : 'none';
      if (this.tabCount) {
        const next = show ? 'inline-flex' : 'none';
        if (this.tabCount.style.display !== next) {
          this.tabCount.style.display = next;
          this.moveIndicator();
        }
      }
      this.syncHeaderBubble(count);
    }

    /* Mirror the count onto the theme header's cart icon immediately so it
       never lags behind the floating cart. */
    syncHeaderBubble(count) {
      const wrapper = document.getElementById('cart-icon-bubble');
      if (!wrapper) return;
      let bubble = wrapper.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.classList.add('cart-count-bubble');
          const num = document.createElement('span');
          num.setAttribute('aria-hidden', 'true');
          const sr = document.createElement('span');
          sr.classList.add('visually-hidden');
          bubble.appendChild(num);
          bubble.appendChild(sr);
          wrapper.appendChild(bubble);
        }
        const num = bubble.querySelector('span[aria-hidden]');
        if (num) num.textContent = count < 100 ? String(count) : '99+';
        const sr = bubble.querySelector('.visually-hidden');
        if (sr) sr.textContent = count + ' items';
      } else if (bubble) {
        bubble.remove();
      }
    }

    /* ---------- cart rendering ---------- */

    rowFor(key) {
      return this.cartItemsEl.querySelector('.nru-cart-item[data-key="' + key + '"]');
    }

    /* Every copy of a photo the browser has already fetched and decoded,
       indexed by the picture itself. Asking for a thumbnail at a width nothing
       on the page has used means a fresh request and an empty box until it
       lands -- which is what the pink square behind the old cart rows was.
       Re-using a copy that is already in memory paints the photo in the same
       frame as the row. */
    decodedPhotos() {
      const found = {};
      const imgs = document.images;
      for (let i = 0; i < imgs.length; i++) {
        const img = imgs[i];
        if (!img.complete || !img.naturalWidth) continue;
        const live = img.currentSrc || img.getAttribute('src') || '';
        if (!live) continue;
        const key = photoKey(live);
        if (!key) continue;
        const width = img.naturalWidth;
        const held = found[key];
        if (!held) {
          found[key] = { src: live, width: width };
          continue;
        }
        /* Prefer the smallest copy that is still sharp on a retina thumbnail;
           only fall back to a smaller-than-wanted one if that is all there is. */
        const wide = width >= 112;
        const heldWide = held.width >= 112;
        let better;
        if (wide && heldWide) better = width < held.width;
        else if (wide) better = true;
        else if (heldWide) better = false;
        else better = width > held.width;
        if (better) found[key] = { src: live, width: width };
      }
      return found;
    }

    thumbFor(item, decoded) {
      const src = item.image;
      if (!src) return null;
      const hit = decoded[photoKey(src)];
      if (hit) return { src: hit.src, ready: true };
      return { src: imgUrl(src, 112), ready: false };
    }

    buildCartItemRow(item, thumb) {
      /* The contract of the shared photo swap: one media box carrying the
         product path, with the photo as its only child. */
      const media = thumb
        ? '<div class="nru-cart-item-media nru-panel-media" data-image-toggle data-product-url="' +
          esc(item.url) +
          '"><img src="' + esc(thumb.src) + '" alt="' + esc(item.product_title) + '" width="56" height="56" ' +
          'loading="eager" decoding="' + (thumb.ready ? 'sync' : 'async') + '"' +
          (thumb.ready ? '' : ' fetchpriority="high"') + '></div>'
        : '<div class="nru-cart-item-media"></div>';
      const vendor = item.vendor ? '<span class="nru-cart-item-vendor">' + esc(item.vendor) + '</span>' : '';
      const variant = item.variant_title
        ? '<span class="nru-cart-item-variant">' + esc(item.variant_title) + '</span>'
        : '';
      return (
        '<div class="nru-cart-item" data-key="' + esc(item.key) + '">' +
        media +
        '<div class="nru-cart-item-info">' +
        vendor +
        '<a href="' + esc(item.url) + '" class="nru-cart-item-title">' + esc(item.product_title) + '</a>' +
        variant +
        '<div class="nru-cart-item-row">' +
        '<div class="nru-cart-qty">' +
        '<button type="button" class="nru-cart-qty-btn" data-nru-qty-decrease aria-label="Decrease quantity">−</button>' +
        '<span class="nru-cart-qty-value" data-nru-qty>' + item.quantity + '</span>' +
        '<button type="button" class="nru-cart-qty-btn" data-nru-qty-increase aria-label="Increase quantity">+</button>' +
        '</div>' +
        '<span class="nru-cart-item-price" data-nru-line-price>' + linePriceHtml(item) + '</span>' +
        '</div>' +
        '</div>' +
        '<button type="button" class="nru-cart-remove" data-nru-remove aria-label="Remove ' + esc(item.product_title) + '">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '</div>'
      );
    }

    bindCartRow(row) {
      const key = row.dataset.key;
      row.querySelector('[data-nru-qty-increase]').addEventListener('click', () => this.adjustQty(key, 1));
      row.querySelector('[data-nru-qty-decrease]').addEventListener('click', () => this.adjustQty(key, -1));
      row.querySelector('[data-nru-remove]').addEventListener('click', () => this.adjustQty(key, -Infinity));
    }

    cartSkeleton(rows) {
      let out = '';
      for (let i = 0; i < rows; i++) {
        out +=
          '<div class="nru-cart-item nru-cart-item--loading">' +
          '<div class="nru-cart-item-media"></div>' +
          '<div class="nru-cart-item-info">' +
          '<div class="nru-skel-line nru-skel-anim" style="width:64%"></div>' +
          '<div class="nru-skel-line nru-skel-anim" style="width:38%;margin-top:8px"></div>' +
          '</div>' +
          '</div>';
      }
      return out;
    }

    async renderCart() {
      const pending = this.pendingAdd;
      if (this.cartCache) {
        this.paintCart();
        if (pending) {
          try {
            await pending;
          } catch (e) {
            /* silent */
          }
          if (this.activeTab === 'cart') this.paintCart();
        }
        return;
      }
      this.cartItemsEl.innerHTML = this.cartSkeleton(2);
      try {
        const res = await fetch('/cart.js');
        this.cartCache = await res.json();
        if (pending) {
          try {
            await pending;
          } catch (e) {
            /* silent */
          }
        }
        this.paintCart();
      } catch (e) {
        this.cartItemsEl.innerHTML = '<p class="nru-cart-loading">Could not load your cart. Please try again.</p>';
      }
    }

    paintCart() {
      const cart = this.cartCache;
      if (!cart || !cart.items || !cart.items.length) {
        this.paintEmpty();
        this.updateTotalsUI();
        return;
      }
      /* Same lines in the same order: keep the rows, and with them their
         already-decoded photos. Rebuilding is what made the thumbnails blink. */
      const rows = Array.prototype.slice.call(this.cartItemsEl.querySelectorAll('.nru-cart-item'));
      const settled =
        rows.length === cart.items.length &&
        rows.every((row, n) => row.dataset.key === cart.items[n].key);
      if (settled) {
        this.updateRows();
        this.updateTotalsUI();
        return;
      }
      const decoded = this.decodedPhotos();
      this.cartItemsEl.innerHTML = cart.items
        .map((item) => this.buildCartItemRow(item, this.thumbFor(item, decoded)))
        .join('');
      this.cartItemsEl.querySelectorAll('.nru-cart-item').forEach((row) => this.bindCartRow(row));
      this.updateTotalsUI();
    }

    updateRows() {
      const cart = this.cartCache;
      if (!cart || !cart.items) return;
      cart.items.forEach((item) => {
        const row = this.rowFor(item.key);
        if (!row) return;
        const qty = row.querySelector('[data-nru-qty]');
        const price = row.querySelector('[data-nru-line-price]');
        if (qty && qty.textContent !== String(item.quantity)) qty.textContent = item.quantity;
        if (price) {
          const next = linePriceHtml(item);
          if (price.innerHTML !== next) price.innerHTML = next;
        }
      });
    }

    paintEmpty() {
      this.cartItemsEl.innerHTML =
        '<div class="nru-cart-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 8h12l-1 12a2 2 0 01-2 2H9a2 2 0 01-2-2L6 8z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9 8V6a3 3 0 016 0v2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '<p>Your cart is empty</p>' +
        '<button type="button" class="nru-cart-empty-btn" data-nru-goto-search>Start searching</button>' +
        '</div>';
      this.cartItemsEl
        .querySelector('[data-nru-goto-search]')
        .addEventListener('click', () => {
          this.switchTab('search');
          this.focusPanel('search', true);
        });
    }

    updateTotalsUI() {
      const cart = this.cartCache;
      const empty = !cart || !cart.items || !cart.items.length;
      /* total_price is only ever the server's own figure (see adjustQty), so the
         subtotal, the threshold message and the progress bar below all read a
         real discount-inclusive total instead of a client-side sum. An emptied
         cart is the one total that needs no server: it is exactly zero. */
      const serverTotal = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
      const total = empty ? 0 : serverTotal;
      this.cartSubtotalEl.textContent = money(total);
      this.cartFooterEl.classList.toggle('is-empty', empty);

      const remaining = this.freeShippingThreshold - total;
      if (empty) {
        this.cartShippingMsgEl.textContent = 'Free shipping on orders over ' + money(this.freeShippingThreshold);
      } else if (remaining <= 0) {
        this.cartShippingMsgEl.textContent = "You've unlocked free shipping! 🎉";
      } else {
        this.cartShippingMsgEl.textContent = money(remaining) + ' away from free shipping';
      }
      const pct = Math.min(100, (total / this.freeShippingThreshold) * 100);
      this.cartShippingBarEl.style.width = pct + '%';
    }

    /* ---------- optimistic cart edits ---------- */

    adjustQty(key, delta) {
      const cart = this.cartCache;
      if (!cart) return;
      const item = cart.items.find((i) => i.key === key);
      if (!item) return;

      const newQty = delta === -Infinity ? 0 : Math.max(0, item.quantity + delta);

      if (newQty === 0) {
        cart.items = cart.items.filter((i) => i.key !== key);
        const row = this.rowFor(key);
        if (row) {
          this.collapseRow(row, () => {
            if (!cart.items.length) this.paintEmpty();
          });
        }
      } else {
        item.quantity = newQty;
        item.final_line_price = item.final_price * newQty;
        item.original_line_price = (item.original_price != null ? item.original_price : item.final_price) * newQty;
        const row = this.rowFor(key);
        if (row) {
          row.querySelector('[data-nru-qty]').textContent = newQty;
          row.querySelector('[data-nru-line-price]').innerHTML = linePriceHtml(item);
        }
      }

      cart.item_count = cart.items.reduce((s, i) => s + i.quantity, 0);
      /* Deliberately do NOT recompute cart.total_price here. Summing the lines
         ignores cart-level automatic discounts ("Stickers - 2 for $5"), so the
         drawer would show a total that is too high until the server answered.
         Leaving it untouched keeps the last total the server gave us on screen;
         syncQty() replaces cartCache with the real one when the response lands,
         and reconcileRows() then repaints the totals from it. */
      this.updateBadge(cart.item_count);
      this.updateTotalsUI();
      this.queueSync(key);
    }

    collapseRow(row, done) {
      row.style.height = row.offsetHeight + 'px';
      row.style.overflow = 'hidden';
      requestAnimationFrame(() => {
        row.style.transition = 'height 0.25s ease, opacity 0.2s ease, padding 0.25s ease';
        row.style.height = '0';
        row.style.opacity = '0';
        row.style.paddingTop = '0';
        row.style.paddingBottom = '0';
        setTimeout(() => {
          row.remove();
          if (done) done();
        }, 260);
      });
    }

    queueSync(key) {
      clearTimeout(this.pendingTimers.get(key));
      this.pendingTimers.set(
        key,
        setTimeout(() => {
          this.pendingTimers.delete(key);
          const item = this.cartCache && this.cartCache.items.find((i) => i.key === key);
          const qty = item ? item.quantity : 0;
          this.syncChain = this.syncChain.then(() => this.syncQty(key, qty)).catch(() => {});
        }, 400)
      );
    }

    async syncQty(key, quantity) {
      const seenWrites = this.foreignCartWrites;
      try {
        /* The watcher reads this flag as the call is made, so it only has to be
           up for that one moment. Holding it up for the whole round trip is
           what let an app's own add go by unnoticed. */
        let request;
        this._selfCartCall = true;
        try {
          request = fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: quantity }),
          });
        } finally {
          this._selfCartCall = false;
        }
        const res = await request;
        if (!res.ok) throw new Error('cart change failed');
        const serverCart = await res.json();
        if (this.pendingTimers.size === 0) {
          if (this.foreignCartWrites !== seenWrites) {
            /* Something else changed the cart while this was in the air, so
               what came back is already a cart or two behind. Ask again. */
            await this.refreshCartBadge();
            if (this.activeTab === 'cart') this.paintCart();
            return;
          }
          this.cartCache = serverCart;
          this.updateBadge(serverCart.item_count);
          this.reconcileRows();
        }
      } catch (e) {
        this.showToast('Couldn’t update your cart — refreshing');
        this.cartCache = null;
        this.refreshCartBadge().then(() => {
          if (this.activeTab === 'cart') this.paintCart();
        });
      }
    }

    reconcileRows() {
      if (this.activeTab !== 'cart' || !this.cartCache) {
        this.updateTotalsUI();
        return;
      }
      this.paintCart();
    }

    showToast(msg) {
      if (!this.toastEl) return;
      this.toastEl.textContent = msg;
      this.toastEl.classList.add('is-visible');
      clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => this.toastEl.classList.remove('is-visible'), 2400);
    }

    /* ---------- search ---------- */

    onInput(e) {
      const term = e.target.value.trim();
      clearTimeout(this.debounceTimer);
      if (!term.length) {
        this.searchToken++;
        this.resultsEl.innerHTML = '';
        this.statusEl.textContent = '';
        this.brandsEl.style.display = 'none';
        this.viewAllEl.classList.remove('is-visible');
        return;
      }
      this.debounceTimer = setTimeout(() => this.search(term), 220);
    }

    setSkeleton() {
      if (!this.resultsEl.childElementCount || this.resultsEl.querySelector('.nru-skel')) {
        const row =
          '<div class="nru-skel"><div class="nru-skel-img nru-skel-anim"></div><div class="nru-skel-lines"><div class="nru-skel-line nru-skel-anim" style="width:70%"></div><div class="nru-skel-line nru-skel-anim" style="width:40%"></div></div></div>';
        this.resultsEl.innerHTML = row + row + row;
      }
    }

    async search(term) {
      const token = ++this.searchToken;
      this.statusEl.textContent = 'Searching…';
      this.setSkeleton();
      let products = [];
      let usedFuzzy = false;
      try {
        const res = await fetch(
          '/search/suggest.json?q=' +
            encodeURIComponent(term) +
            '&resources[type]=product&resources[limit]=8' +
            '&resources[options][unavailable_products]=last' +
            '&resources[options][fields]=title,product_type,variants.title,vendor,tag'
        );
        const data = await res.json();
        products = (data.resources && data.resources.results && data.resources.results.products) || [];
      } catch (e) {
        products = [];
      }
      if (token !== this.searchToken) return;

      if (!products.length) {
        products = await this.fuzzyFallback(term);
        usedFuzzy = true;
        if (token !== this.searchToken) return;
      }

      this.renderResults(products, term, usedFuzzy);
      this.renderBrandChips(term);
    }

    async fuzzyFallback(term) {
      if (!this.allProductsCache) {
        try {
          const res = await fetch('/products.json?limit=250');
          const data = await res.json();
          this.allProductsCache = data.products || [];
        } catch (e) {
          this.allProductsCache = [];
        }
      }
      return this.allProductsCache
        .map((p) => {
          const scores = [
            fuzzyScore(term, p.title),
            fuzzyScore(term, p.product_type),
            fuzzyScore(term, p.vendor),
          ];
          if (p.tags && p.tags.length) scores.push(Math.min.apply(null, p.tags.map((t) => fuzzyScore(term, t))));
          return { p: p, score: Math.min.apply(null, scores) };
        })
        .filter((x) => x.score <= 2)
        .sort((a, b) => a.score - b.score)
        .slice(0, 8)
        .map((x) => ({
          title: x.p.title,
          vendor: x.p.vendor,
          url: '/products/' + x.p.handle,
          image: x.p.images && x.p.images[0] ? x.p.images[0].src : null,
          price: x.p.variants && x.p.variants[0] ? x.p.variants[0].price : null,
        }));
    }

    renderResults(products, term, usedFuzzy) {
      this.viewAllEl.href = '/search?q=' + encodeURIComponent(term) + '&type=product&options%5Bprefix%5D=last';
      this.viewAllEl.classList.add('is-visible');

      if (!products.length) {
        this.statusEl.textContent = 'No matches for “' + term + '” — try another word, or see all results below.';
        this.resultsEl.innerHTML = '';
        return;
      }

      this.statusEl.textContent = usedFuzzy
        ? 'Showing close matches for “' + term + '”'
        : products.length + (products.length === 1 ? ' result' : ' results');

      this.resultsEl.innerHTML = products
        .map((p) => {
          const src = p.image || (p.featured_image && p.featured_image.url) || null;
          /* The photo box the shared photo swap looks for: the product path on
             the box and the picture as its only child. The photo shows the
             product's other picture; the title link is what opens it. */
          const image = src
            ? '<div class="nru-search-result-img nru-panel-media" data-image-toggle data-product-url="' +
              esc(p.url) + '"><img src="' + esc(imgUrl(src, 100)) + '" alt="' + esc(p.title) +
              '" width="48" height="48" loading="lazy"></div>'
            : '<div class="nru-search-result-img nru-search-result-img--empty"></div>';
          /* Predictive search hands prices back as an amount in the shop's
             currency, not in cents. */
          const priceNum = Number(p.price);
          const price =
            p.price && !isNaN(priceNum)
              ? '<span class="nru-search-result-price">' + money(Math.round(priceNum * 100)) + '</span>'
              : '';
          const vendor = p.vendor
            ? '<span class="nru-search-result-vendor">' + esc(p.vendor) + '</span>'
            : '';
          return (
            '<div class="nru-search-result">' +
            image +
            '<span class="nru-search-result-info">' +
            vendor +
            '<a class="nru-search-result-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            price +
            '</span>' +
            '<svg class="nru-search-result-arrow" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
            '</div>'
          );
        })
        .join('');
    }

    renderBrandChips(term) {
      if (!this.vendors.length || term.length < 2) {
        this.brandsEl.style.display = 'none';
        return;
      }
      const matches = this.vendors
        .map((v) => ({ v: v, s: fuzzyScore(term, v) }))
        .filter((x) => x.s <= 2)
        .sort((a, b) => a.s - b.s)
        .slice(0, 4);
      if (!matches.length) {
        this.brandsEl.style.display = 'none';
        return;
      }
      this.brandChipsEl.innerHTML = matches
        .map(
          (x) =>
            '<a class="nru-brand-chip" href="/collections/vendors?q=' + encodeURIComponent(x.v) + '">' + esc(x.v) + '</a>'
        )
        .join('');
      this.brandsEl.style.display = 'flex';
    }
  }

  customElements.define('nru-floating-search', NruFloatingSearch);
})();
